module.exports = __webpack_public_path__ + "assets/images/animations/creando-animation.png?577e09aa";